//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      form: _.extend({
        name: '',
      }, this.initialForm),
      rules: {

      }
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  methods: {
    handleFormSubmit () {
      this.$refs.form.validate((valid) => {
        // console.log('data', data)
        if (valid) {
          let data = _.extend({}, _.pick(this.form, 'name'), {id: this.initialForm.pointId})
          this.loading = true
          this.$axios.post('/mtea/store/admin/dealer/pick/point/update', data).then(res => {
            this.$emit('submit', this.form)
            this.$refs.form.resetFields()
            this.$emit('update:visible', false)
            this.$notify.success({
              title: '系统提示',
              message: '操作成功'
            })
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: '表单校验失败'
          })
          return false
        }
      })
    },
    handleOpen () {
      this.form = _.extend(this.form, this.initialForm)
    },
    handleClose(){
      _.extend(this, _.pick(this.$options.data(), 'form'))
    }
  }
}
